"use strict";

exports.__esModule = true;
exports.default = toArray;
function toArray(value) {
  return value == null ? [] : [].concat(value);
}